module.exports = __webpack_public_path__ + "assets/img/x4.e98302ce.png";